import { Component, ElementRef, inject, Input, OnChanges } from '@angular/core';
import { History, Settings } from 'lucide';
import { Building2, CalendarDays, ChevronDown, ChevronLeft, ChevronRight, ClipboardList, Contact, Contrast, createElement, Download, EyeOff, FileText, Flower2, Hospital, LogOut, Moon, Monitor, Pencil, Pill, Plus, Printer, RefreshCw, Search, ShieldCheck, Stethoscope, Sun, Trash2, Users, Wallet, Waves, X, Check, Eye, type IconNode } from 'lucide';

const icons: Record<string, IconNode> = {
  history: History,
  settings: Settings,
  building: Building2, left: ChevronLeft, right: ChevronRight, clipboard: ClipboardList,
  contact: Contact, file: FileText, hospital: Hospital, logout: LogOut, edit: Pencil, calendar: CalendarDays,
  pill: Pill, plus: Plus, refresh: RefreshCw, search: Search, shield: ShieldCheck,
  stethoscope: Stethoscope, trash: Trash2, users: Users, wallet: Wallet, close: X, check: Check, eye: Eye, 'eye-off': EyeOff,
  print: Printer, download: Download, sun: Sun, moon: Moon, monitor: Monitor, waves: Waves, flower: Flower2, contrast: Contrast, 'chevron-down': ChevronDown,
};

@Component({ selector: 'ipm-icon', template: '', styles: ':host { display: inline-flex; width: 18px; height: 18px; flex-shrink: 0; }' })
export class Icon implements OnChanges {
  @Input() name = 'shield';
  private readonly element = inject(ElementRef<HTMLElement>);

  ngOnChanges(): void {
    const svg = createElement(icons[this.name] ?? ShieldCheck, { width: 18, height: 18, 'stroke-width': 1.7, 'aria-hidden': 'true' });
    this.element.nativeElement.replaceChildren(svg);
  }
}